import React from 'react';
import { motion } from 'framer-motion';
import { Target, Search, ShieldCheck, Handshake } from 'lucide-react';
const steps = [{
  number: '01',
  icon: Target,
  title: 'Responde 5 preguntas',
  description: 'Sobre tu ingreso, trabajo y situación financiera.'
}, {
  number: '02',
  icon: Search,
  title: 'Analizamos tu perfil',
  description: 'Evaluamos tu capacidad real de arriendo.'
}, {
  number: '03',
  icon: ShieldCheck,
  title: 'Te mostramos si calificas',
  description: 'Score, probabilidad y diagnóstico claro.'
}, {
  number: '04',
  icon: Handshake,
  title: 'Mejora antes de postular',
  description: 'Acciones concretas para mejorar tus opciones.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-170">
      <div className="max-w-5xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-173">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 relative" data-id="element-174">
          <div className="hidden md:block absolute top-12 left-[12%] right-[12%] h-px bg-gray-200" data-id="element-175" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center" data-id="element-176">
                <div className="w-24 h-24 rounded-full bg-white shadow-sm flex items-center justify-center relative z-10 mb-6" data-id="element-177">
                  <Icon size={32} className="text-brand-600" data-id="element-178" />
                  <div className="absolute -top-1.5 -right-1.5 w-8 h-8 bg-gray-900 text-white text-sm font-bold rounded-full flex items-center justify-center border-2 border-gray-50" data-id="element-179">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-180">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-181">
                  {step.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}